import type { ExtractFnReturnType } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { chain } from "lodash";
import { type UseQueryOptions, useQuery } from "react-query";
import type { ApiOrder, Order } from "../models/order";
import type { OrderItem } from "../models/order-item";
import { VouchersDistributionsRepository } from "./vouchers-distribution.api";
import type { GetOrderDTO } from "./vouchers-distribution.types";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type QueryFnType = typeof vouchersDistributionsRepository.getOrder;
type ApiData = ExtractFnReturnType<QueryFnType>;
type SelectReturn = { order: Order };
type UseGetOrderOptions = {
  config?: UseQueryOptions<ApiData, AxiosError, SelectReturn>;
} & GetOrderDTO;

export const useGetOrder = ({ config, ...rest }: UseGetOrderOptions) => {
  return useQuery({
    queryKey: ["order", rest.configName],
    queryFn: () => vouchersDistributionsRepository.getOrder(rest),
    select: (data) => ({ order: mapApiOrderToOrder(data.order) }),
    ...config,
  });
};

export const mapApiOrderToOrder = (apiOrder: ApiOrder): Order => {
  const items: OrderItem[] = chain(apiOrder.items)
    .groupBy("productUuid")
    .map((group) => ({
      ...group[0],
      quantity: group.length,
    }))
    .value();

  return {
    ...apiOrder,
    items,
  };
};
